import { useSession } from 'contexts';
import { AbilityContext } from 'contexts/AbilityContext';
import { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Flyout, { useFlyout } from "components/FlyoutMobile/FlyoutMobile";
import { UserCircleIcon, Bars3BottomLeftIcon } from '@heroicons/react/24/solid';
import UserMenuMobile from './UserMenuMobile';
import UserMenu from './UserMenu';
import IntercomChat from 'components/IntercomChat/IntercomChat';

export default function MobileThumbBar({ mobileNav, navigation }: { mobileNav: Array<{ icon; name; active; href; alt?; action?; subject?; }>, navigation: any }) {
  const href = useLocation().pathname;
  const ability = useContext(AbilityContext);
  const { updateFlyout, flyoutProps, closeFlyout } = useFlyout();
  const { craftId, organizationId, organizationType, organizationSubtype } = useSession();
  return (
    <>
      <Flyout {...flyoutProps} />
      <div className="fixed text-brand-pale z-50 bottom-0 left-0 w-screen h-16 md:hidden flex justify-between items-center">
        <div className="w-full h-full bg-brand-dark flex items-center shadow-blue">
          <div
            className="flex h-full flex-col justify-center items-center flex-1 text-xs font-semibold"
            onClick={() => updateFlyout( {title: '', content: 
              <ul className="flex flex-col">
                {navigation.map((item) => {
                  if (item.hidden) return null;
                  const isActive = href === item.href || (item.href !== '/aircraft' && href?.replace('/aircraft', '').includes(item?.href?.replace('/aircraft', '')));
                  const Icon = isActive ? item.iconActive : item.icon;
                  
                  return (
                    <li key={item.name}>
                      {(ability.can(item.action, item.subject) || !item.action) && (
                        <Link
                          to={item.href}
                          onClick={()=>closeFlyout()}
                          className={`flex items-center border-r-4 relative cursor-pointer ${item.subMenu ? 'pl-16 h-10' : 'pl-8 h-12'} ${isActive ? 'text-white bg-brand font-bold border-brand-electric' : 'font-semibold text-brand-pale border-brand-dark'} hover:text-white hover:bg-brand/50`}
                        >
                          <div className="flex items-center">
                            {Icon && <Icon className='w-5 h-5 mr-2' aria-hidden="true"/>}
                            <span
                              className='opacity-100 transition-all ease-in-out duration-300 whitespace-nowrap'>
                              {item.name}
                            </span>
                          </div>
                          <span>{item.badge ?? ''}</span>
                        </Link>
                      )}
                    </li>
                  );
                })}
                <hr className="mx-8 border-brand my-3"/>
                <IntercomChat type="list"/>
              </ul>
            } )}
          >
            <Bars3BottomLeftIcon className="w-6 h-6" aria-hidden="true" />
            Menu
          </div>
          {mobileNav?.map((item, index) => {
            const isActive = href === item.href || (item.href !== '/aircraft' && href?.replace('/aircraft', '').includes(item?.href?.replace('/aircraft', '')));
              return(
                <>
                  <Link to={item.href} key={index} className={`${isActive && 'bg-brand text-white border-t-2 border-brand-electric'} h-full flex flex-col justify-center items-center flex-1 text-xs font-semibold`}>
                    <item.icon className="w-6 h-6" aria-hidden="true" />
                    {item.name}
                  </Link>
                  {index === mobileNav.length-1 &&
                  <div className="flex flex-col items-center justify-center flex-1 relative text-xs font-semibold h-full">
                    <UserMenuMobile className="" />
                    <span className="absolute bottom-3">Profile</span>
                  </div>
                  }
                </>
              )
          })}
        </div>
        {/* <div className="w-[3.67rem] h-full relative pfp-trough shrink-0 flex justify-center items-center bg-brand-dark">
            <div className="relative">
              <UserMenuMobile className="shadow-lg shadow-brand" />
            </div>
        </div> */}
      </div>
    </>
  );
}
